import * as klaro from "klaro";
/*
By default, Klaro will load the config from a global 'klaroConfig' variable. You
can change this by specifying the 'data-klaro-config' attribute on your script:
<script src="klaro.js" data-klaro-config="myConfigVariableName"
*/
var klaroConfig = {
  cookieDomain: window.location.hostname.includes("ddev.site")
    ? undefined
    : window.location.hostname.endsWith(".ytdev.de")
      ? ".ytdev.de"
      : ".freiraum-quartiere.de",
  /*
    Setting 'testing' to 'true' will cause Klaro to not show the consent notice or
    modal by default, except if a special hash tag is appended to the URL (#klaro-
    testing). This makes it possible to test Klaro on your live website without
    affecting normal visitors.
    */
  testing: false,

  /*
    You can customize the ID of the DIV element that Klaro will create when starting
    up. By default, Klaro will use 'klaro'.
    */
  elementID: "klaro",

  /*
    You can customize how Klaro persists consent information in the browser. Specify
    either cookie' (the default) or 'localStorage'.
    */
  storageMethod: "cookie",

  /*
    You can customize the name of the cookie or localStorage entry that Klaro will
    use for storing the consent information. By default, Klaro will use 'klaro'.
    */
  storageName: "klaro",

  /*
    If set to `true`, Klaro will render the texts given in the
    `consentModal.description` and `consentNotice.description` translations as HTML.
    This enables you to e.g. add custom links or interactive content.
    */
  htmlTexts: false,

  /*
    You can change the cookie domain for the consent manager itself. Use this if you
    want to get consent once for multiple matching domains. By default, Klaro will
    use the current domain. Only relevant if 'storageMethod' is set to 'cookie'.
    */
  //   cookieDomain: ".example.com",

  /*
    You can also set a custom expiration time for the Klaro cookie. By default, it
    will expire after 30 days. Only relevant if 'storageMethod' is set to 'cookie'.
    */
  cookieExpiresAfterDays: 30,

  /*
    Defines the default state for services in the consent modal (true=enabled by
    default). You can override this setting in each service.
    */
  default: false,

  /*
    If 'mustConsent' is set to 'true', Klaro will directly display the consent
    manager modal and not allow the user to close it before having actively
    consented or declined the use of third-party services.
    */
  mustConsent: true,
  // noticeAsModal: true,

  /*
    Setting 'acceptAll' to 'true' will show an "accept all" button in the notice and
    modal, which will enable all third-party services if the user clicks on it. If
    set to 'false', there will be an "accept" button that will only enable the
    services that are enabled in the consent modal.
    */
  acceptAll: false,

  /*
    Setting 'hideDeclineAll' to 'true' will hide the "decline" button in the consent
    modal and force the user to open the modal in order to change his/her consent or
    disable all third-party services. We strongly advise you to not use this
    feature, as it opposes the "privacy by default" and "privacy by design"
    principles of the GDPR (but might be acceptable in other legislations such as
    under the CCPA)
    */
  hideDeclineAll: false,

  /*
    Setting 'hideLearnMore' to 'true' will hide the "learn more / customize" link in
    the consent notice. We strongly advise against using this under most
    circumstances, as it keeps the user from customizing his/her consent choices.
    */
  hideLearnMore: false,

  /*
    You can overwrite existing translations and add translations for your service
    descriptions and purposes. See `src/translations/` for a full list of
    translations that can be overwritten:
    https://github.com/KIProtect/klaro/tree/master/src/translations
    */
  translations: {
    /*
        The `zz` key contains default translations that will be used as fallback values.
            This can e.g. be useful for defining a fallback privacy policy URL.
        */
    zz: {
      privacyPolicyUrl: "/privacy",
    },
    de: {
      /*
            You can specify a language-specific link to your privacy policy here.
            */
      privacyPolicyUrl: "/datenschutz",
      consentNotice: {
        description: "Dieser Text wird in der Einwilligungsbox erscheinen.",
      },
      consentModal: {
        title: "Cookie-Einstellungen",
        description:
          "Wir nutzen HubSpot für unsere Formulare. Stimmen Sie zu, um das Kontakt- und Buchungsformular zu verwenden.",
      },
      ok: "Das ist ok",
      /*
            You should also define translations for every purpose you define in the
            'services' section. You can define a title and an (optional) description.
            */
      purposes: {
        formulare: {
          title: "Externe Formulare",
          description:
            "Ermöglicht das Laden unserer Kontakt- und Buchungsformulare über HubSpot.",
        },
        functional: {
          title: "Funktional",
        },
        analytics: {
          title: "Besucher-Statistiken",
        },
        security: {
          title: "Sicherheit",
        },
        livechat: {
          title: "Live Chat",
        },
        advertising: {
          title: "Anzeigen von Werbung",
        },
        styling: {
          title: "Styling",
        },
      },
    },
    en: {
      ok: "That's ok",
      privacyPolicyUrl: "/privacy",
      consentModal: {
        title: "Cookie settings",
        description:
          "We use HubSpot for our forms. Please agree to use the contact and booking form.",
      },
      purposes: {
        analytics: {
          title: "Analytics",
        },
        security: {
          title: "Security",
        },
        livechat: {
          title: "Livechat",
        },
        advertising: {
          title: "Advertising",
        },
        styling: {
          title: "Styling",
        },
      },
    },
  },

  /*
    Here you specify the third-party services that Klaro will manage for you.
    */
  services: [
    // {
    //   name: "youtube",
    //   contextualConsentOnly: true,
    //   purposes: ["advertising"],
    //   translations: {
    //     zz: { title: "YouTube" },
    //     en: { description: "YouTube video embeds." },
    //     de: { description: "YouTube Video-Einbettungen." },
    //   },
    // },
    {
      name: "hubspot",
      // contextualConsentOnly: true,
      translations: {
        zz: { title: "HubSpot" },
        de: {
          title: "HubSpot",
          description:
            "Ermöglicht das Laden unserer Kontakt- und Buchungsformulare über HubSpot.",
        },
        en: {
          title: "HubSpot",
          description:
            "Enables loading of our contact and booking forms via HubSpot.",
        },
      },
      purposes: ["formulare"],
      default: false,
      required: false,
      optOut: false,
      onlyOnce: false,
    },
  ],

  /*
    You can define an optional callback function that will be called each time the
    consent state for any given service changes. The consent value will be passed as
    the first parameter to the function (true=consented). The `service` config will
    be passed as the second parameter.
    */
  callback: function (consent, service) {
    console.log(
      "User consent for service " + service.name + ": consent=" + consent,
    );

    if (service.name === "hubspot" && consent) {
      function tryInit() {
        if (typeof (window as any).hbspt === "undefined") {
          console.log("hbspt not ready, retrying...");
          setTimeout(tryInit, 200);
          return;
        }

        console.log("hbspt ready");

        const placeholders = document.querySelectorAll(
          '[data-type="placeholder"][data-name="hubspot"]',
        );
        console.log("placeholders found:", placeholders.length);
        placeholders.forEach((el) => el.remove());

        const containers = document.querySelectorAll(
          '[data-form-id][data-name="hubspot"]',
        );
        console.log("containers found:", containers.length);
        containers.forEach(function (el) {
          console.log(
            "container:",
            el.id,
            "display:",
            (el as HTMLElement).style.display,
          );
          (el as HTMLElement).style.display = "block";
          (window as any).hbspt.forms.create({
            portalId: "146186768",
            formId: el.getAttribute("data-form-id"),
            region: "eu1",
            target: "#" + el.id,
          });
        });
      }
      tryInit();
    }
  },
};

(window as any).klaroConfig = klaroConfig;
klaro.setup(klaroConfig);

document.getElementById("klaro-open")?.addEventListener("click", (e) => {
  e.preventDefault();
  klaro.show(undefined, true);
});
